import {SiteEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {SiteAction} from "./SiteActionMenu";
import {useSiteMutation} from "../../../hooks/useSiteMutation";

export type UseSiteActionProps = {}

export type UseSiteActionResult = {
  onSiteActionClick: (site: SiteEntity, action: SiteAction) => void;
}

export const useSiteAction = (props: UseSiteActionProps = {}): UseSiteActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    updateSiteTransportViaPipeline,
    updateSiteTransportOilViaPipeline,
  } = useSiteMutation()

  const _onSiteActionClick = useCallback((site: SiteEntity, action: SiteAction) => {
    if (action === "EDIT") {
      navigate(`/sites/form`, {state: {id: site.id}})
    } else if (action === "TOGGLE_TRANSPORT_VIA_PIPELINE") {
      updateSiteTransportViaPipeline(site.id, !site.transportViaPipeline)
    } else if (action === "TOGGLE_TRANSPORT_OIL_VIA_PIPELINE") {
      updateSiteTransportOilViaPipeline(site.id, !site.transportOilViaPipeline)
    }
  }, [navigate, updateSiteTransportViaPipeline, updateSiteTransportOilViaPipeline])

  return {
    onSiteActionClick: _onSiteActionClick
  }
}
